module.exports = __webpack_public_path__ + "static/scale-model-of-balloon-safari-in-escondido-california-48648eef6f876157ce3e38e7ca2a31be.png";